export enum ServerStatus {
  OK = 0,
  SAVING = 1,
  SAVE_ERROR = -1,
  UPDATING = 2,
  UPDATE_ERROR = -2,
  DELETING = 3,
  DELETE_ERROR = -3
}
